module.exports = __webpack_public_path__ + "img/logo.0259ae86.png";